// extracted by mini-css-extract-plugin
module.exports = {"customModal":"modal_customModal__pNabT","warningCollapse":"modal_warningCollapse__mHrpZ"};